import { GET_BUSINESS_REP_LIST_PO } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_BUSINESS_REP_LIST_PO:
            return action.payload;
        default:
            return state;
    }
}